/*
 * @Date: 2025-06-10 09:20:12
 * @LastEditors: Joan Zhang
 * @LastEditTime: 2025-06-12 17:47:11
 * @FilePath: /PID_Project/PID-frontend/src/hooks/useSessionStorage.js
 */
import { useState, useEffect } from 'react';

// Custom hook to store a state variable in a browser's local storage
// Pass in a key to store the value under (can just use the state variable's name) and a default value
// Returns an array with the local storage state variable and the function to set the state variable
export default function useSessionStorage(key, defaultValue) {
	const [value, setValue] = useState(() => {
		const storedValue = typeof window !== 'undefined' ? sessionStorage.getItem(key) : null;
		if (storedValue === null) {
			return defaultValue;
		}
		try {
			return JSON.parse(storedValue);
		} catch (e) {
			// If parsing fails, return the raw string value
			return storedValue;
		}
	});

	useEffect(() => {
		const listener = (e) => {
			if (typeof window !== 'undefined' && e.storageArea === sessionStorage && e.key === key) {
				if (e.newValue === null) {
					setValue(defaultValue);
				} else {
					try {
						setValue(JSON.parse(e.newValue));
					} catch (e) {
						// If parsing fails, use the raw string value
						setValue(e.newValue);
					}
				}
			}
		};
		window.addEventListener('storage', listener);

		return () => {
			window.removeEventListener('storage', listener);
		};
	}, [key, defaultValue]);

	const setValueInSessionStorage = (newValue) => {
		setValue((currentValue) => {
			const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;
			if (typeof window !== 'undefined') {
				// Only try to stringify if the value is not a string
				const valueToStore = typeof result === 'string' ? result : JSON.stringify(result);
				sessionStorage.setItem(key, valueToStore);
			}
			return result;
		});
	};

	return [value, setValueInSessionStorage];
}